import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';
import { Panel, TabsPanel, CreateButton } from '@ixicare/ui';
import { Permission } from '@ixicare/resources';
import { HcpGroupsTable } from '~/components/HcpGroupsTable';
import { HcpGroupCreateEditModal } from '~/containers/HcpGroups/HcpGroupCreateEditModal';
import { HcpAssignmentTab } from '~/containers/HcpGroups/HcpAssignmentTab';
import { ZoneAssignmentTab } from '~/containers/HcpGroups/ZoneAssignmentTab';
import { useSiteConfiguration } from '~containers/ConfigurationForm/ConfigurationForm';

const HcpGroupsPage = () => {
  const [creationPermission, setCreationPermission] = React.useState<boolean>(false);
  const [editPermission, setEditPermission] = React.useState<boolean>(false);
  const [showCreateModal, setShowCreateModal] = React.useState<boolean>(false);

  React.useEffect(() => {
    Permission.getOwnPermissions().then((value) => {
      if (value.length != 0) {
        value[0].entries.find((perm) => {
          if (perm.permission.name.includes('can_create_hcp_groups')) {
            if (perm.isEnabled) {
              setCreationPermission(true);
            }
          }
          if (perm.permission.name.includes('can_edit_all_hcp_groups')) {
            if (perm.isEnabled) {
              setEditPermission(true);
            }
          }
        });
      }
    });
  }, []);
  const hcpGroupsTable = React.useMemo(() => {
    return <HcpGroupsTable canCreate={creationPermission} canEdit={editPermission} />;
  }, [creationPermission, editPermission]);

  const tabs = React.useMemo(() => {
    return [
      {
        label: t('hcpGroups.tabs.groups'),
        id: 'groups',
        content: hcpGroupsTable,
      },
      {
        label: t('hcpGroups.tabs.assignHcps'),
        id: 'assignHcps',
        content: <HcpAssignmentTab />,
      },
      {
        label: t('hcpGroups.tabs.assignZones'),
        id: 'assignZones',
        content: <ZoneAssignmentTab />,
      },
    ];
  }, [hcpGroupsTable]);

  const { data: siteConfig } = useSiteConfiguration();
  const isSegmentationEnabled = siteConfig?.['enable-segmentation'] ?? false;

  return (
    <>
      {!isSegmentationEnabled && (
        <div
          style={{
            marginBottom: '20px',
            padding: '15px',
            backgroundColor: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '4px',
          }}
        >
          <p style={{ margin: 0 }}>
            {t('hcpGroups.segmentation.disabled.message')}{' '}
            <a href="/configuration" style={{ textDecoration: 'underline', color: '#856404', fontWeight: 'bold' }}>
              {t('hcpGroups.segmentation.disabled.link')}
            </a>
          </p>
        </div>
      )}
      <Panel>{editPermission ? <TabsPanel tabs={tabs} useHash={true} /> : hcpGroupsTable}</Panel>
      {creationPermission && <CreateButton atBottom onClick={() => setShowCreateModal(true)} />}
      {showCreateModal && <HcpGroupCreateEditModal onClose={() => setShowCreateModal(false)} />}
    </>
  );
};

export default dashboardWrapper(HcpGroupsPage, t('menu.dashboard.hcpGroups'));
